<div class="alert alert-info"
     role="alert">
    <ng-content></ng-content>
    @if (url) {
        <a href="{{ url }}"
           rel="noreferrer noopener"
           target="_blank">{{ text }}</a>
    }
</div>
